import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, CommunicationConfigService } from '@argalis-apps/angular-global';
import { MDuree } from '@argalis-apps/models';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DureeService {
  constructor(
    private communicationConfigService: CommunicationConfigService,
    private configService: ConfigService,
    private http: HttpClient
  ) {}

  get(): Observable<MDuree.IDuree[]> {
    if (this.configService?.getOptions()?.useTestData === true) {
      return of([
        { id: 1, libelle: '1 jour' },
        { id: 2, libelle: '2 jours' },
        { id: 3, libelle: '3 jours' },
        { id: 4, libelle: '4 jours et plus' }
      ]);
    } else {
      return this.http.get<MDuree.IDuree[]>(`${this.communicationConfigService.getApiUri()}/duree_formation`);
    }
  }
}
